import React from "react";

const LoadingScreen = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <div>
        <img
          src="https://cdn.dribbble.com/users/450343/screenshots/2465762/media/97b14be7af51dcea4d8ae244c545769b.gif"
          alt=""
        />
      </div>
    </div>
  );
};

export default LoadingScreen;
